import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { sanitizeReturnTo } from '../../auth/returnTo';
import { getPaymentAnalyticsContext, trackEventOnce } from '../../utils/analytics';
import { useTranslation } from 'react-i18next';
import { localize } from '../../i18n/locale';

const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0f172a',
    color: '#fff',
    padding: '2rem',
    textAlign: 'center',
};

export default function PaymentFail() {
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();
    const tr = (ko, en) => localize(i18n.resolvedLanguage || i18n.language, { ko, en });
    const [searchParams] = useSearchParams();
    const message = useMemo(
        () => searchParams.get('message') || searchParams.get('failMessage') || searchParams.get('code') || 'The payment was not completed.',
        [searchParams],
    );
    const retryPath = useMemo(
        () => sanitizeReturnTo(searchParams.get('returnTo') || '', '/mypage'),
        [searchParams],
    );

    useEffect(() => {
        if (searchParams.get('analytics_tracked') === '1') return;
        const code = searchParams.get('code') || '';
        const productId = searchParams.get('productId') || '';
        const isCancellation = code.includes('CANCEL');
        trackEventOnce('payment_failed', `toss:${location.key}:${code || 'provider_error'}`, {
            product_id: productId || undefined,
            payment_provider: 'toss',
            currency: 'KRW',
            failure_reason: isCancellation ? 'user_cancelled' : 'provider_error',
            failure_stage: isCancellation ? 'cancellation' : 'approval',
            error_type: isCancellation ? 'user_cancelled' : 'provider_error',
            ...getPaymentAnalyticsContext(productId),
        });
    }, [location.key, searchParams]);

    return (
        <div style={containerStyle}>
            <div>
                <h1 style={{ marginBottom: '1rem' }}>{tr('결제에 실패했습니다', 'Payment failed')}</h1>
                <p style={{ color: '#cbd5e1', marginBottom: '1.5rem' }}>{message}</p>
                <button
                    type="button"
                    onClick={() => navigate(retryPath)}
                    style={{
                        border: 'none',
                        borderRadius: '12px',
                        padding: '0.95rem 1.25rem',
                        background: 'linear-gradient(135deg, #f59e0b, #ea580c)',
                        color: '#fff',
                        fontWeight: 700,
                        cursor: 'pointer',
                    }}
                >
                    {tr('돌아가기', 'Go Back')}
                </button>
            </div>
        </div>
    );
}
